/**
 * Calculate the km's between 2 position objects, given the latitude and longitude of both positions
 *
 * Function originally found at https://stackoverflow.com/a/27943,
 * and has been refactored here
 *
 * @param {{ lat: float|string, lng: float|string }} coord1 The first position
 * @param {{ lat: float|string, lng: float|string }} coord2 The second position
 *
 * @returns {float}
 */
define([], () => {
    function deg2rad(deg) {
        return deg * (Math.PI / 180);
    }

    return (coord1, coord2) => {
        const { lat: lat1, lng: lon1 } = coord1;
        const { lat: lat2, lng: lon2 } = coord2;

        const R = 6371; // Radius of the earth in km
        const dLat = deg2rad(lat2 - lat1);
        const dLon = deg2rad(lon2 - lon1);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
            + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
            * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c; // Distance in km

        return d.toFixed(2);
    };
});
